import React from 'react';
import { getAnchorTagTrainRoutes } from '../utils/recommendTripPathListUtils';
import PropTypes from 'prop-types';

export const StationRouteRecommend = ({
  stationRouteProps: { destination, source, routePageUrl },
  idx,
  recommendObject,
  data
}) => (
  <li key={`${destination}_${idx}`} className="appendBottom10">
    <a href={routePageUrl} className="font14 darkGreyText railSeoWrap__rwStnListLink">
      {getAnchorTagTrainRoutes({
        stringToFormat: recommendObject.format,
        replaceSourceWith: source || data.stationInfo.obj.city,
        replaceDestWith: destination || data.stationInfo.obj.city
      })}
    </a>
  </li>
);

StationRouteRecommend.propTypes = {
  stationRouteProps: PropTypes.object,
  idx: PropTypes.number,
  recommendObject: PropTypes.object,
  data: PropTypes.object
};
export default StationRouteRecommend;
